/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Col,
  Form,
  Input,
  Row,
  UploadProps,
  Space,
  Upload,
  Divider,
  Modal,
} from 'antd';
import { Content } from 'antd/lib/layout/layout';
import { useHistory } from 'react-router-dom';
import Button from 'components/Button';
import { useState } from 'react';
import { useMutation } from 'react-query';
import { ColumnsType } from 'antd/es/table';
import { DEFAULT_PAGE_SIZE } from 'utils/constants';
import useQueryParam from 'hooks/useQueryPrams';
import { Table } from 'antd/lib';
import { HocChangePagination } from 'utils/HocChangePagination';
import * as XLSX from 'xlsx';
import { DownloadOutlined } from '@ant-design/icons';
import { allocationDetails } from 'interface/allowcate.interface';
import { openNotificationWithIcon } from 'utils/notification';
import RoleBasedAuth from 'apis/RoleBasedAPI';

interface IProps {
  isModalImportVisible: boolean;
  onCancel: () => void;
  handleUpdateUser: (data: any) => void;
  isLoading: boolean;
}

export default function UserImportPlant(props: IProps): JSX.Element {
  const { isModalImportVisible, onCancel } = props;
  const [dataImport, setDataImport] = useState<any>();

  const history = useHistory();

  const queryParam = useQueryParam();

  const [excelData, setExcelData] = useState<allocationDetails[]>([]);
  const [fileName, setFileName] = useState<string>();

  const page = parseInt(queryParam.get('page') + '') || 1;

  const page_size =
    parseInt(queryParam.get('page_size') + '') || DEFAULT_PAGE_SIZE;

  const columns: ColumnsType<any> = [
    {
      title: 'STT',
      dataIndex: 'id',
      width: 20,
      render: (text, record, index) => index + 1 + page_size * (page - 1),
    },
    {
      title: 'DC plant',
      width: 100,
      dataIndex: 'dcPlant',
    },
    {
      title: 'ASM email',
      width: 100,
      dataIndex: 'email',
    },
    {
      title: 'Mã Plant quản lý',
      dataIndex: 'plantCode',
      width: 100,
    },
  ];

  function handleFileChange(info: UploadProps) {
    if (info.fileList) {
      const files = info.fileList.map((file: any) => {
        return file.originFileObj;
      });
      if (files.length != 0) {
        const file = info.fileList[0];
        // setSelectedFile(file);
        const reader = new FileReader();
        setFileName(file.name);
        reader.onload = (e) => {
          if (e.target) {
            const data = e.target.result;
            const workbook = XLSX.read(data, { type: 'array' });
            const firstSheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[firstSheetName];
            const excelData = XLSX.utils.sheet_to_json<any[]>(worksheet, {
              header: 1,
              range: 0,
            });
            // console.log(excelData);
            let jsonData: any = [];
            const tableData: any = [];
            for (let i = 1; i < excelData.length; i++) {
              if (excelData[0].length < 3) {
                openNotificationWithIcon(
                  'error',
                  'Template file excel không đúng!'
                );
                jsonData = [];
                break;
              }
              const paramData = excelData[i];
              if (paramData.length > 0) {
                if (paramData[0] == undefined || paramData[0] == null) {
                  openNotificationWithIcon(
                    'error',
                    `Dòng ${i + 1} thiếu DC plant!!!`
                  );
                  jsonData = [];
                  break;
                }

                if (paramData[1] == undefined || paramData[0] == null) {
                  openNotificationWithIcon(
                    'error',
                    `Dòng ${i + 1} thiếu ASM email!!!`
                  );
                  jsonData = [];
                  break;
                }

                if (paramData[1].search('@pnj.com.vn') < 0) {
                  openNotificationWithIcon(
                    'error',
                    `Dòng ${i + 1} của ASM email chứa email không hợp lệ!!!`
                  );
                  jsonData = [];
                  break;
                }

                if (paramData[2] == undefined || paramData[0] == null) {
                  openNotificationWithIcon(
                    'error',
                    `Dòng ${i + 1} thiếu mã Plant quản lý!!!`
                  );
                  jsonData = [];
                  break;
                }

                if (jsonData.length > 0) {
                  let check = 0;
                  for (const item of jsonData) {
                    if (item.email == paramData[1]) {
                      item.plant_codes.push(String(paramData[2]));
                      check = 0;
                      break;
                    } else check = 1;
                  }
                  if (check == 1) {
                    const param = {
                      email: String(paramData[1]),
                      plant_codes: [String(paramData[2])],
                    } as unknown as allocationDetails;
                    jsonData.push(param);
                  }
                } else {
                  const param = {
                    email: String(paramData[1]),
                    plant_codes: [String(paramData[2])],
                  } as unknown as allocationDetails;
                  jsonData.push(param);
                }
                const paramTable = {
                  dcPlant: [paramData[0]],
                  email: String(paramData[1]),
                  plantCode: [paramData[2]],
                } as unknown as allocationDetails;

                tableData.push(paramTable);
              }
              if (tableData.length == 0 && i == excelData.length - 1) {
                openNotificationWithIcon(
                  'error',
                  `Vui lòng kiểm tra lại nội dung file Excel!!!`
                );
              }
            }
            setExcelData(tableData);
            setDataImport(jsonData);
          }
        };

        const blob = file.originFileObj as Blob;
        reader.readAsArrayBuffer(blob);
      } else {
        setFileName(undefined);
      }
    } else {
      setFileName(undefined);
    }
  }

  const { mutate: syncAsmUserPlant } = useMutation(
    RoleBasedAuth.postSyncAsmUserPlant,
    {
      onSuccess: (data: any) => {
        if (data.status == 200) {
          openNotificationWithIcon('success', data.message);
          onCancel();
        } else {
          openNotificationWithIcon('error', data.message);
        }
      },
      onError: (data: any) => {
        console.log(data);
        openNotificationWithIcon('error', data.message.toString());
      },
    }
  );

  function generateExcel() {
    const data = [];

    // create title
    const headerRow = columns.map((column) => {
      if (column.title != 'STT') return column.title;
    });

    data.push(headerRow.slice(1, 4));

    // create data
    excelData.forEach((prm) => {
      const rowData = columns.map((column) => {
        return prm[column.dataIndex];
      });
      data.push(rowData.slice(1, 4));
    });

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet(data);
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, `mau_import_plant.xlsx`);
  }

  const handleSave = async () => {
    syncAsmUserPlant(dataImport);
  };

  return (
    <Modal
      title="Phân quyền người dùng"
      visible={isModalImportVisible}
      onCancel={onCancel}
      footer={null}
      //   centered={true}
      width={900}
      className="bg-white p-2 gap-4 lg:w-90 md:w-90 sm:w-100"
    >
      <Content>
        <Row
          gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
          justify="space-between"
          align="middle"
          className="mb-3"
        >
          <Col span={24}>
            <Row justify="end">
              <Space>
                <Button
                  bgColor={'bg-white'}
                  color={'text-primary-50'}
                  border={'border-primary-50'}
                  customClass="fix-border-radius"
                  onClick={generateExcel}
                >
                  <DownloadOutlined />
                  Tải file excel
                </Button>
              </Space>
            </Row>
          </Col>
        </Row>
        <Form layout="vertical">
          <Row align="middle" gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="mr-8" span={19}>
              <Form.Item label="Danh sách plant" rules={[{ required: true }]}>
                <Input
                  disabled={true}
                  placeholder="nhập file"
                  className=""
                  value={fileName}
                />
              </Form.Item>
            </Col>
            <Col span={3} className="flex justify-end">
              <Upload
                accept=".xlsx,.xls,.csv"
                onChange={handleFileChange}
                beforeUpload={() => false}
                fileList={[]}
                showUploadList={false}
              >
                <Button
                  bgColor={'bg-white'}
                  color={'text-primary-50'}
                  border={'border-primary-50'}
                  customClass="fix-border-radius"
                >
                  Browser
                </Button>
              </Upload>
            </Col>
          </Row>
        </Form>
        {excelData.length > 0 && (
          <Table
            rowKey={(record) => record.id}
            columns={columns}
            className="customTable"
            dataSource={excelData}
            pagination={{
              className: 'flex items-center',
              current: page,
              pageSize: page_size,
              // total: data?.total,
              showSizeChanger: true,
              pageSizeOptions: ['10', '20', '50'],
              onChange: HocChangePagination(history),
            }}
          />
        )}
      </Content>
      <Divider
        style={{
          borderTop: '1px solid rgba(0, 0, 0, 0.2)',
          marginTop: '8px',
          marginBottom: '8px',
        }}
      />
      <Row
        className="mt-8"
        gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
        justify="end"
        style={{ marginTop: '20px', marginRight: '2px' }}
      >
        <Col className="flex justify-end">
          <Button
            disabled={excelData.length > 0 ? false : true}
            bgColor={excelData.length > 0 ? 'bg-primary-50' : 'bg-gray-300'}
            onClick={handleSave}
          >
            Lưu
          </Button>
        </Col>
      </Row>
    </Modal>
  );
}
